var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.views)?_c('b-form',{attrs:{"inline":""}},[_c('label',{staticClass:"mr-sm-2",attrs:{"for":"inline-form-custom-select-pref"}},[_vm._v(" View: ")]),_c('b-form-select',{staticClass:"mb-2 mr-sm-2 mb-sm-0",attrs:{"id":"mdmViewsDropdown","options":_vm.views,"value":_vm.selectedView.viewGuid},on:{"change":_vm.chooseView}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }